import { styled } from '@vw-marketing/us-components';

interface ParagraphContainerProps {
  readonly marginBottom?: string;
}

export const ParagraphContainer: any = styled.div<ParagraphContainerProps>`
  margin-bottom: ${(props: ParagraphContainerProps) =>
    props.marginBottom ? `${props.marginBottom};` : '30px;'};
`;

interface RichtextWrapperProps {
  readonly textColor?: string;
  readonly linkColor?: string;
}

export const RichtextWrapper: any = styled.div<RichtextWrapperProps>`
  ${(props: RichtextWrapperProps) =>
    props.textColor && `color: ${props.textColor}`}

  a {
    ${(props: RichtextWrapperProps) =>
      props.linkColor && `color: ${props.linkColor}`}
  }
`;
